import { memo, useEffect } from 'react';
import {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
  withDelay,
} from 'react-native-reanimated';
import { runOnJS } from 'react-native-worklets';
import { AnimatedCoinProps } from './AnimatedCoin.types';
import Image from '../../Image/Image';
import Box from '../../Box/Box';

function AnimatedCoin({
  cx,
  cy,
  rx,
  ry,
  index,
  fromAngle,
  toAngle,
  variant,
  duration,
  delay,
  onAnimationFinish,
}: AnimatedCoinProps) {
  const animatedValue = useSharedValue(0);
  const animatedStyle = useAnimatedStyle(() => {
    const theta = fromAngle - (toAngle - fromAngle) * animatedValue.value;
    const x = cx + rx * Math.cos(theta);
    const y = cy + ry * Math.sin(theta);

    return {
      opacity: Number(animatedValue.value !== 0),
      transform: [{ translateX: x }, { translateY: y }],
    };
  });

  useEffect(() => {
    animatedValue.value = withDelay(
      delay,
      withTiming(1, { duration }, () => {
        animatedValue.value = 0;

        if (onAnimationFinish) {
          runOnJS(onAnimationFinish)(index);
        }
      }),
    );
  }, [index, delay, duration, animatedValue, onAnimationFinish]);

  return (
    <Box
      position="absolute"
      top="space-0"
      left="space-0"
      width="space-500"
      height="space-500"
      animatedStyle={animatedStyle}
    >
      <Image name={`common.coinAngle_${variant}`} width="100%" height="100%" />
    </Box>
  );
}

export default memo(AnimatedCoin);
